/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCSVAllowedFieldFromJSON, ApiCSVAllowedFieldToJSON, } from './ApiCSVAllowedField';
import { ApiCSVFieldTypeFromJSON, ApiCSVFieldTypeToJSON, } from './ApiCSVFieldType';
export function ApiCSVFieldFromJSON(json) {
    return ApiCSVFieldFromJSONTyped(json, false);
}
export function ApiCSVFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allowedValues': !exists(json, 'allowedValues') ? undefined : (json['allowedValues'].map(ApiCSVAllowedFieldFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'forceUserValue': !exists(json, 'forceUserValue') ? undefined : json['forceUserValue'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'must': !exists(json, 'must') ? undefined : json['must'],
        'required': !exists(json, 'required') ? undefined : json['required'],
        'type': !exists(json, 'type') ? undefined : ApiCSVFieldTypeFromJSON(json['type']),
        'uiParent': !exists(json, 'uiParent') ? undefined : json['uiParent'],
        'userValueAllowed': !exists(json, 'userValueAllowed') ? undefined : json['userValueAllowed'],
    };
}
export function ApiCSVFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'allowedValues': value.allowedValues === undefined ? undefined : (value.allowedValues.map(ApiCSVAllowedFieldToJSON)),
        'description': value.description,
        'forceUserValue': value.forceUserValue,
        'id': value.id,
        'must': value.must,
        'required': value.required,
        'type': ApiCSVFieldTypeToJSON(value.type),
        'uiParent': value.uiParent,
        'userValueAllowed': value.userValueAllowed,
    };
}
